
<section class="card-profile-admin">
  <h3 v-if="card.adminNotes || pendingSales.length > 0" class="section-header secondary-font">
    Admin
  </h3>

  <template v-if="loaded">
    <p v-if="card.adminNotes" class="admin-notes">
      {{ card.adminNotes }}
    </p>

    <h5 v-if="pendingSales.length > 0" class="secondary-font">
      Pending Sales
    </h5>

    <section v-if="pendingSales.length > 0" :class="['pending-sales-list', { full: page }]">
      <pending-sales-item
        v-for="pendingSale in pendingSales"
        :id="pendingSale.itemId"
        :key="pendingSale.itemId"
        hide-graph
        :sale="pendingSale"
        @remove="removePendingSaleFromList"
        @update="updatePendingSale"
        @purgatory="sendToPurgatory"
      />
    </section>
  </template>

  <spinner v-else />
</section>
